import React from 'react'
import Progress from 'react-progress-2'
import 'react-progress-2/main.css'
import { Provider, useSelector } from 'react-redux'
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import styled from 'styled-components'
import './App.css'
import { TEMPLATE_BLUE } from './const/color'
import {
  CATEGORIES_ROUTE,
  CATEGORY_MANAGEMENT_ROUTE,
  SIGN_IN_ROUTE,
} from './const/route'
import PageNotFound from './layouts/PageNotFound'
import PublicLayout from './layouts/public'
import PublisherLayout from './layouts/publisher'
import SignInPublisher from './modules/auths/SignInPublisher'
import CategoriesPage from './modules/categories/CategoriesPage'
import CategoryManagementPage from './modules/categoryManagement/CategoryManagementPage'
import configureStore from './store'

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => (
        <PublicLayout>
          <Component {...props} />
        </PublicLayout>
      )}
    />
  )
}

const PublisherRoute = ({ component: Component, ...rest }) => {
  const { currentUser } = useSelector(state => state.auth)
  return (
    <Route
      {...rest}
      render={props =>
        currentUser.isPublisher ? (
          <PublisherLayout
            title={rest.title}
            isPublisher={currentUser.isPublisher}
          >
            <Component {...props} />
          </PublisherLayout>
        ) : (
          <Redirect
            to={{
              pathname: SIGN_IN_ROUTE,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  )
}

const App = () => {
  return (
    <div className="App">
      <ProgressWrapper>
        <Progress.Component />
      </ProgressWrapper>

      <Router>
        <Switch>
          <PublicRoute path={SIGN_IN_ROUTE} component={SignInPublisher} exact />

          <PublisherRoute
            path={CATEGORY_MANAGEMENT_ROUTE}
            component={CategoryManagementPage}
            exact
          />

          <PublisherRoute
            path={CATEGORIES_ROUTE}
            component={CategoriesPage}
            exact
          />

          <Route path="/404" component={PageNotFound} />
          <Redirect path="/" to={CATEGORIES_ROUTE} />
          <Redirect path="*" to="/404" />
        </Switch>
      </Router>
    </div>
  )
}

const ProgressWrapper = styled.div`
  height: 0.2rem;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;

  .loader-60devs {
    z-index: 10051;
  }
  .loader-60devs .loader-60devs-progress {
    height: 0.2rem;
    width: 100%;
    background-color: ${TEMPLATE_BLUE};
  }
  /* comment below if you want react-progress-2 to block UI */
  .loader-60devs::before {
    display: none;
  }
`

const Container = () => {
  const reduxStore = configureStore()
  return (
    <Provider store={reduxStore.store}>
      <PersistGate loading={null} persistor={reduxStore.persistor}>
        <App />
      </PersistGate>
    </Provider>
  )
}

export default Container
